import PropTypes from 'prop-types';
import React from 'react';
import { Translate } from 'react-redux-i18n';
import { Flex, Label } from 'rebass';
import styled from 'styled-components';
import { space, width } from 'styled-system';
import { PvBox, PvButtonOutline, PvInput } from 'styles/CustomComponents';
import { PvCheckbox } from 'components/form/PvCheckbox';

const PvSearchBtn = styled(PvButtonOutline)`
  ${space}
  ${width}
  word-wrap: break-word;
`;

const paddingLeft = {
  paddingLeft: '5px'
};


class TheoryApplicantsSearch extends React.Component {
  constructor(props) {
    super(props);
    this.state = {
      datePickerOpen: false
    };
  }

  render() {

    const {
      filters,
      updateApplicantFilters,
      currentCourse
    } = this.props;

    return (
      <PvBox my={3}>
        <Flex flexWrap='wrap'>
          <PvBox mb={3} w={[1, 1, 1 / 3]}>
            <PvBox display='inline-block' px={2} w={3 / 10}>
              <Label mb={2}>
                <Translate value='search.theory_course_number' />
              </Label>
              <PvInput
                type='search'
                value={currentCourse.courseNumber}
                disabled />
            </PvBox>
            <PvBox display='inline-block' px={2} w={3 / 10}>
              <Label mb={2}>
                <Translate value='search.course_year' />
              </Label>
              <PvInput
                type='search'
                value={currentCourse.courseYear}
                disabled />
            </PvBox>
            <PvBox display='inline-block' px={2} w={4 / 10}>
              <Label mb={2}>
                <Translate value='search.course_unit' />
              </Label>
              <PvInput
                type='search'
                value={currentCourse.courseUnit}
                disabled />
            </PvBox>
          </PvBox>
          <PvBox mb={3} w={[1, 1, 2 / 3]}>
            <PvBox display='inline-block' px={2} w={1 / 4}>
              <Label mb={2}>
                <Translate value='search.team' />
              </Label>
              <PvInput
                type='search'
                value={filters.team}
                onChange={(e) => updateApplicantFilters({team: e.target.value})} />
            </PvBox>
            <PvBox display='inline-block' px={2} w={2 / 4}>
              <Label mb={2}>
                <Translate value='search.applicant_name' />
              </Label>
              <PvInput
                type='search'
                value={filters.name}
                onChange={(e) => updateApplicantFilters({name: e.target.value})} />
            </PvBox>
            <PvBox display='inline-block' px={2} w={1 / 4}>
              <PvSearchBtn
                px={0} width='100%'
                onClick={() => updateApplicantFilters({
                  courseNumber: '',
                  courseUnit: '',
                  courseYear: '',
                  team: '',
                  name: ''
                })}>
                <Translate value='action.clear_search' />
              </PvSearchBtn>
            </PvBox>
          </PvBox>
          <PvBox mb={3} w={[1, 1, 1 / 2]}>
            <Label mb={2}>
              <PvCheckbox type="checkbox" defaultChecked={filters.onlyUndone}
                          onChange={(e) => updateApplicantFilters({ onlyUndone : e.target.checked })}
              />
              <Translate value='search.only_applicants_with_undone' style={paddingLeft} />
            </Label>
          </PvBox>
        </Flex>
      </PvBox>
    );
  }
}

TheoryApplicantsSearch.propTypes = {
  filters: PropTypes.object,
  currentCourse: PropTypes.object,
  loading: PropTypes.bool,
  updateApplicantFilters: PropTypes.func,
};

export default TheoryApplicantsSearch;



// WEBPACK FOOTER //
// ./src/containers/search/TheoryApplicantsSearch.jsx